export { default as EventDetailView } from './EventDetailView';
export type {
	EventDetailViewProps,
	EventDetailTextSection
} from './EventDetailView.types';
